import React from 'react'
import s from './AccordionContainer.module.css'

export interface AccordionContainerProps {
  children?: any
  title?: string
  darkMode?: string
  className?: string
  key?: any
  color?: string
  colorDark?: string
}

const AccordionContainer: React.FC<AccordionContainerProps> = ((props) => {

  const {
    children,
    className,
    title,
    color,
    colorDark
  } = props

  return (
    <div className={`${s.root} ${className} accordion_container`} style={(color ? {backgroundColor: color} : { backgroundColor: 'var(--neutral200)' })}>
      { title && <h3 className={` text-heading02 font-medium mb-space2 ${s.title}`}>{title}</h3> }
      <div className={s.inner}>
        <div>
          {children}
        </div>
      </div>
    </div>
  )
})

export default AccordionContainer
